<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'
import { richTextImgHandler } from '@/utils/common'

export default {
  name: 'Comp59',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, richTextImgHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-59">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-59-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-58-${i}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`, borderColor: `${getPageThemeColor(path)}`}"
        class="item"
        @click="onModuleItem(v)"
      >
        <el-image class="item-avator" :src="v.photo | imgPath" alt="avator" />
        <div class="item-content">
          <p class="h-line-1 item-title">{{ v.name || '' }}</p>
          <p class="h-line-2 item-memo">{{ v.memo || '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-59-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 20px;
}
.item {
  width: 340px;
  height: 135px;
  background-color: #fff;
  border: 1px solid;
  box-sizing: border-box;
  box-shadow: 0px 4px 15px 0px rgba(23,23,23,0.1);
  border-radius: 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  margin-left: 7px;
}
.item-avator {
  position: absolute;
  top: 16px;
  left: -7px;
  width: 76px;
  height: 100px;
  border-radius: 5px;
}
.item-content {
  width: 228px;
  color: #000;
  margin-right: 16px;
  .item-title {
    font-size: 17px;
    font-weight: bold;
  }
  .item-memo {
    margin-top: 20px;
    font-size: 14px;
  }
}
</style>
